<template>
  <div class="flex items-center justify-between">
    <p>{{ deal.business.business_legal_name }}</p>
    <div class="flex items-center space-x-4">
      <div v-if="deal.deal_mode">
        <div
          class="flex w-auto grow-0 justify-center rounded-full px-2-5 py-2 text-center text-xxs font-bold uppercase"
          :style="oldModeStyle"
        >
          <div v-if="deal.deal_mode" class="flex space-x-2 whitespace-nowrap">
            <icon-base
              v-if="deal.deal_mode === DEAL_MODE_TEST_KEY"
              :icon="IconSandbox"
            />
            <span>{{ DEAL_MODES[deal.deal_mode] }}</span>
          </div>
        </div>
      </div>
      <lf-badge v-else class="rounded-full">-</lf-badge>
      <icon-chevron-up class="-rotate-90" :fill="`rgb(${COLORS[15]})`" />
      <div
        class="flex w-auto grow-0 justify-center rounded-full px-2-5 py-2 text-center text-xxs font-bold uppercase"
        :style="newModeStyle"
      >
        <div v-if="deal.deal_mode" class="flex space-x-2 whitespace-nowrap">
          <icon-base
            v-if="selectedValue.toLowerCase() === DEAL_MODE_TEST.toLowerCase()"
            :icon="IconSandbox"
          />
          <span>{{ selectedValue }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { type PropType, computed } from "vue";

import type { IApplication } from "@/models/applications";
</script>
<script setup lang="ts">
import {
  COLORS,
  DEAL_MODES,
  DEAL_MODE_COLOR_CODES,
  DEAL_MODE_LIVE,
  DEAL_MODE_TEST,
  DEAL_MODE_TEST_KEY,
  DEAL_MODE_TEXT_COLOR_CODES,
} from "@/helpers/constants";

import IconSandbox from "@/components/icons/IconSandbox.vue";

const props = defineProps({
  deal: {
    type: Object as PropType<IApplication>,
    required: true,
  },
  selectedValue: {
    type: String,
    required: true,
  },
});

const oldModeStyle = computed(() => {
  if (!props.deal.deal_mode) {
    return {
      backgroundColor: `rgb(${COLORS[15]})`,
      borderStyle: "none",
    };
  }

  return {
    ...getBackgroundStyle(DEAL_MODES[props.deal.deal_mode]),
    ...getTextStyle(DEAL_MODES[props.deal.deal_mode]),
  };
});

const newModeStyle = computed(() => ({
  ...getBackgroundStyle(props.selectedValue),
  ...getTextStyle(props.selectedValue),
}));

const getColorIndex = (mode: string) => {
  return DEAL_MODE_COLOR_CODES[mode as keyof typeof DEAL_MODE_COLOR_CODES];
};

const getTextColorIndex = (mode: string) => {
  return DEAL_MODE_TEXT_COLOR_CODES[
    mode as keyof typeof DEAL_MODE_TEXT_COLOR_CODES
  ];
};

const getBackgroundStyle = (mode: string) => {
  return {
    backgroundColor:
      mode === DEAL_MODE_LIVE
        ? `rgb(${COLORS[getColorIndex(mode)]}, 0.2)`
        : `rgb(${COLORS[getColorIndex(mode)]})`,
    borderStyle: "none",
  };
};

const getTextStyle = (mode: string) => {
  return {
    color: `rgb(${COLORS[getTextColorIndex(mode)]})`,
  };
};
</script>
